import type { MouseEventHandler, ReactNode } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import NestableClickable from 'components/Common/NestableClickable'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { mediaHoverable } from 'lib/theme/mediaQueries'
import focusStyle from 'styles/utils/focusStyle'
import { TRIP_PLANNER_NAVIGATION_GUTTER } from './tripPlannerNavigationConstants'

const RowTitle = styled.div`
  min-inline-size: 0;
`

const RowActions = styled.div`
  display: flex;
`

const Row = styled(NestableClickable)`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
  padding-block: ${rem(8)};
  padding-inline: ${rem(TRIP_PLANNER_NAVIGATION_GUTTER)} ${rem(8)};
  transition: background-color 200ms;

  > ${RowTitle} {
    flex: 1;
  }

  > ${RowActions} {
    flex-shrink: 0;
  }

  ${mediaQueryUp.tablet} {
    padding-block: ${rem(4)};
  }

  &[aria-current='page'] {
    background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
  }

  &:focus-visible {
    ${focusStyle}
  }

  ${mediaHoverable} {
    &:hover {
      background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
    }

    /* Touch keeps the menu visible; an open menu is portaled, so its expanded trigger keeps it shown. */
    &:not([aria-current]):not(:hover):not(:focus-within) > ${RowActions}:not(:has([aria-expanded='true'])) {
      opacity: 0;
    }
  }
`

interface Props {
  title: ReactNode
  actions?: ReactNode
  to?: string
  current?: boolean
  onClick?: MouseEventHandler
}

function TripPlannerNavigationRow({ title, actions, to, current = false, onClick }: Props) {
  return (
    <Row to={to} onClick={onClick} aria-current={current ? 'page' : undefined}>
      <RowTitle>{title}</RowTitle>
      {!!actions && <RowActions>{actions}</RowActions>}
    </Row>
  )
}

export default TripPlannerNavigationRow
